import React, { useContext, useEffect } from 'react';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { bool, func, number } from 'prop-types';
import { useLocation } from 'react-router-dom';
import { MDialog } from 'common';
import { AuthContext } from 'authentication/AuthContext';
import { createSnack } from 'snackbar/snackbarSlice';
import { createSnackButtons } from 'utils/helpers/function';

// Context
import { DrawerContext } from 'common/drawer/DrawerContext';

import { DRAWER_TYPES } from 'utils/constants';
import {
  resetEditPto,
  sendEditPtoDetails,
  sendEditPtoDetailsResetError,
} from '../store/editOrderDetails';
import { setPtoNumber } from '../store/orderDrawer';
import { fetchOpenPTOs } from '../store/openOrder';
import { fetchSearchPTOs } from '../store/searchOrder';
// eslint-disable-next-line import/no-cycle
import ViewPanelConnector from '../view-panel/ViewPanel.connector';

const EditPtoDialog = ({
  closeDialog,
  dialogOpen,
  fetchNotifications,
  ptoNumber,
  refreshNotifications,
  resetCreatePto,
}) => {
  const dispatch = useDispatch();
  const { affiliateRoles, roles: inputRoles } = useContext(AuthContext);
  const { setDrawerComponentProps } = useContext(DrawerContext);
  const submitEditPto = () => {
    dispatch(sendEditPtoDetails(ptoNumber)).then(() => {
      if (refreshNotifications) {
        const currentRoles = [...inputRoles, ...affiliateRoles];
        fetchNotifications(currentRoles);
      }
    });
  };
  const response = useSelector(state => state.pto.editPtoDetails.response);
  const error = useSelector(state => state.pto.editPtoDetails.sendError);

  const { pathname } = useLocation();

  const handleSnackClose = () => {
    dispatch(sendEditPtoDetailsResetError());
    closeDialog();
  };

  useEffect(() => {
    if (response.productTransferOrderId) {
      dispatch(setPtoNumber(ptoNumber));
      setDrawerComponentProps({
        Component: '',
        refreshNotifications: false,
        resetWizard: undefined,
        type: '',
      });
      dispatch(
        createSnack({
          message: `Product Transfer Order ${ptoNumber} Submitted`,
          options: {
            action: createSnackButtons([
              {
                label: 'VIEW ORDER',
                onClick: () =>
                  setDrawerComponentProps({
                    Component: props => <ViewPanelConnector ptoNumber={ptoNumber} {...props} />,
                    resetWizard: resetCreatePto,
                    type: DRAWER_TYPES.viewPtoDetails,
                  }),
              },
            ]),
            onClose: () => {
              dispatch(resetEditPto());
              closeDialog();
            },
          },
        })
      );
      pathname.includes('open') ? dispatch(fetchOpenPTOs()) : dispatch(fetchSearchPTOs());
    }
    if (error) {
      dispatch(
        createSnack({
          message: error,
          options: {
            onClose: handleSnackClose,
            variant: 'error',
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response, error, ptoNumber, dispatch, closeDialog]);
  return (
    <MDialog
      centeredHeader
      header={`Edit order ${ptoNumber}?`}
      leftButtonAction={closeDialog}
      leftButtonText="Back"
      onClose={closeDialog}
      open={dialogOpen}
      rightButtonAction={submitEditPto}
      rightButtonText="Confirm"
    >
      <Typography component="p" variant="body1">
        {`Would you like to save your changes to PTO Number ${ptoNumber}?`}
      </Typography>
    </MDialog>
  );
};

EditPtoDialog.propTypes = {
  closeDialog: func.isRequired,
  dialogOpen: bool.isRequired,
  fetchNotifications: func.isRequired,
  ptoNumber: number.isRequired,
  refreshNotifications: bool,
  resetCreatePto: func.isRequired,
};

EditPtoDialog.defaultProps = {
  refreshNotifications: null,
};

export default EditPtoDialog;
